import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import RegisterInterestButton from "./RegisterInterestButton";
import { safeSessionGet, safeSessionSet } from "@/lib/browser-storage";

const SESSION_KEY = "utc-register-interest-shown";
const DELAY_MS = 10_000;

const EXCLUDED_PREFIXES = ["/auth", "/dashboard", "/admin", "/onboarding", "/reset-password"];

/**
 * Mounts globally. After 10s on any non-excluded page, auto-opens the
 * Register Interest funnel — once per browser session.
 */
const AutoRegisterInterestPopup = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  const excluded =
    EXCLUDED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/")) ||
    pathname.startsWith("/club/"); // skip tenant public sites

  useEffect(() => {
    if (excluded) return;
    if (safeSessionGet(SESSION_KEY) === "1") return;

    const t = window.setTimeout(() => {
      if (safeSessionGet(SESSION_KEY) === "1") return;
      safeSessionSet(SESSION_KEY, "1");
      setOpen(true);
    }, DELAY_MS);

    return () => window.clearTimeout(t);
  }, [excluded, pathname]);

  if (excluded) return null;

  return (
    <RegisterInterestButton
      triggerless
      controlledOpen={open}
      onOpenChange={setOpen}
      source="auto-popup-10s"
    />
  );
};

export default AutoRegisterInterestPopup;
